<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppDatePicker from '@/components/app/DatePicker.vue';
export default {
  name: 'workStartModal',
  components: { AppDatePicker },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
      required: true,
    },
    allPhonesList: {
      type: Array,
      default: () => [],
      required: true,
    },
    allCitiesList: {
      type: Array,
      default: () => [],
      required: true,
    },
    defaultFields: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      filterData: {
        phoneId: null,
        cityId: null,
        fromDate: null,
        toDate: null,
        Pilot: null,
      },
      isModalOpenTest: true,
    };
  },
  methods: {
    setFilter: function () {
      this.$emit('set-filter', this.filterData);
    },
  },
  watch: {
    defaultFields: {
      handler(currentVal) {
        this.filterData = currentVal;
      },
      immediate: true,
    },
  },
};
</script>
<template>
  <v-dialog :value="true" width="350">
    <v-card>
      <v-row no-gutters>
        <v-col cols="12" class="modal-header py-2">
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-icon color="darkColor">mdi-magnify mdi-18px</v-icon>
            <span class="modal-title-text ml-n11">جستجو...</span>
            <v-spacer></v-spacer>
            <v-icon class="ml-3" @click="$emit('close-modal')">mdi-close</v-icon>
          </v-row>
        </v-col>
      </v-row>
      <v-card-text class="py-4">
        <v-row no-gutters>
          <v-row>
            <v-col cols="12">
              <v-autocomplete :items="allPhonesList" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                clear-icon="mdi-close-circle-outline" item-text="code" item-value="id" label="کد گوشی"
                v-model="filterData.phoneId" autocomplete="off" prepend-inner-icon="mdi-phone mdi-18px"
                hide-details></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="allCitiesList" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="شهر"
                v-model="filterData.cityId" autocomplete="off" prepend-inner-icon="mdi-city mdi-18px"
                hide-details></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" v-model="filterData.Pilot" dense clearable clear-icon="mdi-close-circle-outline"
                outlined label="خلبان" class="input-label" prepend-inner-icon="mdi-account mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="12">
              <app-date-picker dense inputID="fromDate" label="تاریخ شروع" :const-value="defaultFields.fromDate"
                v-model="filterData.fromDate" />
            </v-col>
            <v-col cols="12">
              <app-date-picker dense inputID="toDate" label="تاریخ پایان" :const-value="defaultFields.toDate"
                v-model="filterData.toDate" />
            </v-col>
          </v-row>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="setFilter()" dark rounded class="normal-letter-spacing px-12 ml-5">
            جستجو
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="$emit('close-modal')" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style lang="css"></style>
